// HomeCard.js
// White card shell used by every Home module: title row with an optional
// right-aligned action link, and an optional "hero" brand ring.
import React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";

import { HOME, homeColors } from "../homeTheme";

const HomeCard = ({
  title = null,
  action = null,
  hero = false,
  isDarkMode = false,
  children,
  testID,
  style,
}) => {
  const colors = homeColors(isDarkMode);

  return (
    <View
      testID={testID}
      style={[
        styles.card,
        {
          backgroundColor: colors.cardBg,
          borderColor: hero ? colors.brand : colors.line,
        },
        hero && {
          shadowColor: colors.brandSoft,
          shadowOffset: { width: 0, height: 0 },
          shadowOpacity: 1,
          shadowRadius: HOME.heroRing,
          elevation: 0,
        },
        style,
      ]}
    >
      {title ? (
        <View style={styles.headerRow}>
          <Text style={[styles.title, { color: colors.ink3 }]}>{title}</Text>
          {action ? (
            <TouchableOpacity
              onPress={action.onPress}
              testID={testID ? `${testID}-action` : undefined}
              accessibilityRole="button"
              accessibilityLabel={action.label}
            >
              <Text style={[styles.actionLabel, { color: colors.brand }]}>
                {action.label}
              </Text>
            </TouchableOpacity>
          ) : null}
        </View>
      ) : null}
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    borderRadius: HOME.radius,
    borderWidth: 1,
    padding: HOME.pad,
  },
  headerRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  title: {
    fontSize: HOME.labelSize,
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: 0.4,
  },
  actionLabel: {
    fontSize: HOME.labelSize,
    fontWeight: "600",
  },
});

export default HomeCard;
